import React, { Component } from 'react'
import ModalBasic from '../../pages/component/ModalBasic';

export default function UploadBookingReports(props) {

    return (
        <>
            <ModalBasic
                id="upload-booking-reports"
                className="upload-booking-reports"
                modalOpen={props.setUploadBookingReports}
                setModalOpen={props.setOpenModal}
                title="Upload Booking Reports"
            >



                <div className="custom-card shadow-lg mb-30  w-[1000px]">
                    <div className="flex items-center justify-between w-1/2 mb-5">
                        <div className=" font-bold text-[#757575] text-[16px]  text-gray-800">
                            Upload File
                        </div>
                    </div>
                    <div className="col-span-12 mb-5">
                        <div className="flex items-center mb-3 gap-4">
                            <label className="text-[#757575] text-[16px] mobile-14 whitespace-nowrap">
                                File
                            </label>

                            <div className="flex flex-1 items-center gap-4">
                                <input
                                    className="w-1/2 custom-input"
                                    type="text"
                                    value={props.fileDetails.fileName}
                                    disabled={true}
                                />

                                {/* <form className="custom-uploader custom-file-upload-btn flex justify-center items-center text-center btn btn-red-border">
                                    <label
                                        htmlFor="upload_File1"
                                        className="text-uplod block text-sm font-bold text-[#C00000] whitespace-nowrap cursor-pointer"
                                    >
                                        Select File
                                    </label>
                                    <input
                                        className="sr-only"
                                        id="upload_File1"
                                        type="file"
                                        name="file1"
                                        onChange={(event) => props.onFileChange(event, "fileDetails")}
                                        accept=".xls, .xlsx"
                                    />
                                </form> */}
                                <label
                                    htmlFor="upload_File1"
                                    className="custom-uploader custom-file-upload-btn flex justify-center items-center text-center btn btn-red-border text-uplod block text-sm font-bold text-[#C00000] whitespace-nowrap cursor-pointer"
                                >
                                    Select File
                                    <input
                                        className="sr-only"
                                        id="upload_File1"
                                        type="file"
                                        name="file1"
                                        onChange={(event) => props.onFileChange(event, "fileDetails")}
                                        accept=".xls, .xlsx"
                                    />
                                </label>




                                <div className="col-span-12 flex justify-start">
                                    <button className={`w-32 px-7 py-2 btn-sm btn-red text-lg text-white `}
                                        onClick={() => {
                                            props.updateFiles();
                                        }}
                                    >
                                        Update
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

            </ModalBasic>
        </>
    )

}
